<script>
import {updateMontant} from '../../../mixins/updateMontant.js';

export default {
  name: 'factureline',
  props:{
    phaseName: String,
    pourcentage: Number,
    montantHT: Number,
    tva: Number,
  },
  mixins:[
    updateMontant,
  ],
  data(){
    return {
      
    }
  },
  mounted(){
    
  },
  methods:{
    
  }
}
</script>


<template>
  <div class="factureLine">
    <span class="left factureLine-name"> {{phaseName}} </span>
    <div class="right"><span> {{pourcentage}}</span><span class="factureLine__unit">%</span></div>
    <div class="right"><span> {{updateMontant(montantHT).str}}</span><span class="factureLine__unit">€<sup>ht</sup></span></div>
    <div class="right"><span>Tva : </span><span> {{tva}}</span><span class="factureLine__unit">%</span></div>
    <div class="right"><span> {{updateMontant(Math.round(100*montantHT * (1 + (tva / 100)))/100).str}}</span><span class="factureLine__unit">€<sup>ttc</sup></span></div>
  </div>
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../../assets/main.scss';

.factureLine{
    display: grid; //Grid identique au footer du parent "factureItem" et à l'élément "ligneFormulaire"
    grid-template-columns: 3fr 1fr 2fr 2fr 2fr;
    @include myFont;
    font-size: 13px;
    margin: 0 0 3px 0;
    color: $black-bolder;

  &__unit{
    margin: 0px 0px 0px 3px;
  }

  &-name{
    @include monoline;
    width: 100%;
  }

//   &__error{
//     color: $alert !important;
//     background-color: $alert-lighter;
//   }
}

.center{
  justify-self: center;
}

.left{
  justify-self: left;
}

.right{
  justify-self: right;
}

</style>
